<template>
    <div class="category-wrapper">
        <div
            class="category-body"
            v-for="category in categories"
            v-if="category.product_count > 0 && !category.is_all_hidden"
            :key="category.id"
        >
            <div
                class="category-item"
                :class="{ active: currentCategoryId === category.id }"
                @click="selectProductCategory(category.id)"
            >
                <div
                    class="category"
                    :class="`sub-category-level-${subCategoryLevel}`"
                >
                    <div class="category-text">
                        <div
                            v-if="category.id > 0 || category.virtual_count"
                            class="count"
                        >
                            {{ productCountText(category.id > 0 ? category.product_count : category.virtual_count) }}
                        </div>
                        <div class="name theme-primary-color">
                            {{ category.name }}
                        </div>
                    </div>
                </div>
                <div
                    v-if="category.children?.length && checkChildrenProductCount(category)"
                    class="arrow-right"
                    :class="{ open: isDropdownOpen(category.id) }"
                    @click.stop="toggleDropdown(category.id)"
                >
                    <i class="icon-chevronright"></i>
                </div>
            </div>
            <div
                v-if="category.children?.length && isDropdownOpen(category.id)"
                class="subcategory-wrapper"
            >
                <div class="subcategory">
                    <!-- <div
                    class="category-item"
                    :class="{ active: currentCategoryId === subcategory.id }"
                    >
                    <div
                        class="category"
                        @click="selectProductCategory(subcategory.id)"
                    >
                        <div class="name theme-primary-color">
                            {{ subcategory.name }}
                        </div>
                    </div>
                    </div> -->

                    <bo-catalog-category
                        :categories="category.children"
                        @select-category="selectProductCategory"
                        :current-category-id="currentCategoryId"
                        :sub-category-level="subCategoryLevel + 1"
                    >
                    </bo-catalog-category>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        categories: {
            type: Array,
            default: [],
        },
        currentCategoryId: {
            type: Number,
            default: null,
        },
        subCategoryLevel: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            openDropdowns: {},
            catalogTranslations: window.bo?.catalogTranslations ?? {},
            generalTranslations: window.bo?.generalTranslations ?? {},
        };
    },
    methods: {
        productCountText(count) {
            return (this.catalogTranslations.products_count ?? ":count Products").replace(":count", count ?? 0);
        },
        selectProductCategory(id) {
            this.$emit("select-category", id);
        },
        toggleDropdown(categoryId) {
            const currentVisibleState = this.isDropdownOpen(categoryId);
            this.$set(this.openDropdowns, categoryId, !currentVisibleState);
        },
        isDropdownOpen(categoryId) {
            if (this.openDropdowns[categoryId] !== undefined) {
                return this.openDropdowns[categoryId];
            }
            // Check if the dropdown is manually opened or if any subcategory is active
            const category = Object.values(this.categories).find((cat) => cat.id === categoryId);
            return category ? this.checkActiveSubcategory(category) : false;
        },
        checkActiveSubcategory(category) {
            if (category.id === this.currentCategoryId) {
                return true;
            } else if (category.children) {
                return category.children.some((subcategory) => {
                    return this.checkActiveSubcategory(subcategory);
                });
            } else {
                return false;
            }
        },
        checkChildrenProductCount(category) {
            if (category.has_visible_children !== undefined) {
                return category.has_visible_children;
            }

            if (category.children && category.children.length > 0) {
                return category.children.some((child) => child.product_count > 0);
            } else {
                return false;
            }
        },
    },
};
</script>
